"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.activation.subject': 'Activa tu cuenta',
    'email.activation.title': '¡Bienvenido a IntHub!',
    'email.activation.text': 'Gracias por registrarte en IntHub. Para completar tu registro y activar tu cuenta, haz clic en el botón de abajo.',
    'email.activation.button': 'Activar cuenta',
};
